// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__gWMOA","spinner":"Loading_spinner__33ZUp"};